import { Tag } from 'lucide-react';
import { forwardRef } from 'react';

import { tv } from '@/utils/styles';

export interface ComboboxMultiPillProps {
  selectedValues: string[];
  onTogglePopover: () => void;
  placeholder: string;
  className?: string;
  isOpen?: boolean;
}

const ComboboxTagsTrigger = forwardRef<HTMLButtonElement, ComboboxMultiPillProps>(
  ({ selectedValues, placeholder = 'Add tag', className, isOpen, onTogglePopover }, ref) => {
    const getLabel = () => {
      if (selectedValues.length) {
        return selectedValues.length > 1 ? `+${selectedValues.length} tags` : selectedValues[0];
      }
      return placeholder;
    };

    const { base, icon, buttonText } = styles({ hasSelectedItems: selectedValues.length !== 0 });

    return (
      <button
        type="button"
        ref={ref}
        aria-expanded={isOpen}
        className={base({ className })}
        // style prop required because max-w refuses to work 🤷‍
        style={{ maxWidth: '100%' }}
        onClick={(e) => {
          e.stopPropagation();
          onTogglePopover();
        }}
      >
        {selectedValues.length === 0 ? <Tag className={icon()} size={14} /> : null}
        <span className={buttonText()}>{getLabel()}</span>
      </button>
    );
  },
);

ComboboxTagsTrigger.displayName = 'ComboboxTagsTrigger';

const styles = tv({
  slots: {
    base: 'group flex h-7 items-center rounded-full px-2 text-baseSm text-grey-500 hover:border-grey-600 hover:text-text-primary aria-expanded:border-grey-600 aria-expanded:text-text-primary',
    icon: 'mr-1 text-grey-500 group-hover:text-text-primary',
    buttonText: 'truncate',
  },
  variants: {
    hasSelectedItems: {
      true: {
        base: 'bg-grey-100 px-3 text-text-primary',
      },
      false: {
        base: 'border border-dashed border-grey-300',
      },
    },
  },
});

export { ComboboxTagsTrigger };
